import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useMediaQuery } from "../../utilities/index.js";
import React from "react";
export const Blob = ({ containerSx = {}, icon, subtitle, title }) => {
    const theme = useTheme();
    const isAtLeastLg = useMediaQuery(theme.breakpoints.up("lg"));
    return (React.createElement(Box, { sx: containerSx },
        React.createElement(Stack, { alignItems: "center", direction: "row" },
            React.createElement(Box, { sx: {
                    width: { xs: theme.spacing(14), lg: theme.spacing(20) },
                    mr: 1,
                    svg: { transform: "scale(1.25)" },
                } }, icon),
            React.createElement(Stack, { direction: "column" },
                React.createElement(Typography, { sx: { pb: { xs: 0.5, lg: 1 }, width: "100%" }, variant: "h3" }, title),
                React.createElement(Typography, { variant: isAtLeastLg ? "body1" : "body2", sx: { pb: 1 } }, subtitle)))));
};
//# sourceMappingURL=blob.js.map